export default [
	{
		handle: { crumb: () => 'Planning participation' },
		path: '/website_entertainments/:websiteEntertainmentId/planning_participations/:mode',
		lazy: async () => {
			const Module = await import('../pages/Planning/PlanningParticipationsPage');
			return { Component: Module.default  };
		},
	},
];
